var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.title}},[_c('el-date-picker',{key:_vm.cascaderkey,attrs:{"type":"daterange","start-placeholder":"开始日期","range-separator":"至","end-placeholder":"结束日期","value-format":"yyyy-MM-dd"},on:{"change":_vm.DateChange},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }